import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export const useDeleteDashboardTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.dashboard.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.dashboard.dashboards.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.dashboard.dashboardById.queryKey(),
        });
      },
    }),
  });

  return {
    deleteDashboard: async (variables: { Id: string }): Promise<void> => {
      await mutation.mutateAsync({ Id: variables.Id });
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
